module.exports = __webpack_public_path__ + "fonts/GalanoGrotesque-SemiBold.ae7d1fa.woff2";